import { mapState } from "vuex";
export const shopsIndexMixins = {
  computed: {
    shopsTopBarList() {
      let topbarList = [
        {
          name: "店铺管理",
          isActive: false,
          path: "/shops",
          icon:require("@/assets/img/menuIcons/icon-shops.png")
        },
      ];
      topbarList.forEach((val) => {
        if (val.path == this.$route.path) {
          val.isActive = true;
        }
      });
      return topbarList;
    },
  },
}
